import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { get_user_invoices } from '../../redux/actions/payment';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import CreateInvoice from './createInvoice';
import EditAddress from './editAddress';
import EditInvoice from './editInvoice';
const UserInvoices = ({
    user,
    invoices,
    get_user_invoices,
    petition_invoices
}) => {

    useEffect(() => {
        let data = {
            'user_id': user.id
        }
        get_user_invoices(data);
    }, [get_user_invoices]);

    useEffect(() => {
        if (!petition_invoices) {
            let data = {
                'user_id': user.id
            } // Si no está haciendo la petición de compras
            get_user_invoices(data);  // Vuelve a cargar las compras
        }
    }, [petition_invoices, get_user_invoices]);

    const getStateColor = (state) => {
        switch (state) {
            case 0:
                return 'bg-gray-500 text-white';
            case 1:
                return 'bg-green-500 text-white';
            default:
                return 'bg-gray-500 text-white';
        }
    };

    return (
        <div className="max-w-6xl mx-xl-auto mt-12 mx-4 p-4 bg-white rounded-xl border shadow-sm">

            <h2 className="text-2xl font-bold mb-4 text-ecoprimary1">Tus datos de facturación</h2>
            <CreateInvoice
                updateList={get_user_invoices}
            />
            {petition_invoices ? (
                <div className="flex justify-center">
                    <div className="animate-spin border-4 border-t-4 border-orange-500 border-solid rounded-full w-10 h-10"></div>
                </div>
            ) : invoices.length === 0 ? (
                <div className='bg-blue-100 rounded-3 p-2 w-fit'>
                    <p className="text-ecoprimary1 mb-0">No tienes datos registrados</p>
                </div>
            ) : (
                <>
                    <div className="overflow-x-auto w-full">
                        <table className="min-w-full text-sm rounded-lg overflow-hidden divide-y divide-gray-200">
                            <thead className="bg-blue-200 text-ecoprimary1">
                                <tr>
                                    <th className="px-3 py-2 text-left min-w-[50px]">ID</th>
                                    <th className="px-2 py-2 text-left min-w-[120px]">Nombre</th>
                                    <th className="px-2 py-2 text-left min-w-[120px]">NIT</th>
                                    <th className="px-2 py-2 text-left w-[50px]">Predeterminado</th>
                                    <th className="px-2 py-2 text-left w-[50px]">Opciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                {invoices.map((invoice, index) => (
                                    <tr key={index} className="bg-blue-50">
                                        <td className="px-3 py-2">{invoice.id}</td>
                                        <td className="px-2 py-2">{invoice.name}</td>
                                        <td className="px-2 py-2">{invoice.nit}</td>
                                        <td className="px-2 py-2">
                                            {
                                                invoice.is_check == 1 &&
                                                <span className={`px-2 py-1 rounded-full text-xs font-medium uppercase ${getStateColor(invoice.is_check)}`}>
                                                    <FontAwesomeIcon icon={faCheck} size="lg" />
                                                </span>
                                            }

                                        </td>
                                        <td className="px-2 py-2">
                                            <EditInvoice
                                                currentInvoice={invoice}
                                                updateList={get_user_invoices}
                                            />
                                        </td>

                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </>
            )}
        </div>
    );
};

const mapStateToProps = state => ({
    user: state.Auth.user,
    invoices: state.Payment.invoices,
    petition_invoices: state.Payment.petition_invoices
});

export default connect(mapStateToProps, { get_user_invoices })(UserInvoices);
